import { Map } from 'immutable';
import { ReduxAction } from 'types/redux.types';
import { whatsNewModalActions } from './actions';
import { WhatsNewOpenModeType } from '__generated__/graphql';

const initState = Map({
  visible: false,
  openMode: WhatsNewOpenModeType.New, // Default mode
});

export default function whatsNewModalReducer(state = initState, action: ReduxAction) {
  switch (action.type) {
    case whatsNewModalActions.SHOW_WHATS_NEW_MODAL:
      return state.set('visible', action.payload);
    case whatsNewModalActions.TOGGLE_WHATS_NEW_MODAL:
      return state.set('visible', !state.get('visible'));
    case whatsNewModalActions.SET_WHATS_NEW_OPEN_MODE:
      return state.set('openMode', action.payload);
    default:
      return state;
  }
}